import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { PersonShippingAddressAddPage } from 'src/app/modals/person-shipping-address-add/person-shipping-address-add.page';

const routes: Routes = [
  {
    path: '',
    component: PersonShippingAddressAddPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PersonShippingAddressAddPage]
})
export class PersonShippingAddressAddPageModule {}
